import { FlaskConical } from 'lucide-react';

import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';

/**
 * Small amber "Test" badge marking an entity flagged as test data.
 * Render conditionally next to the row/detail title.
 */
export function TestBadge({ className }: { className?: string }) {
  return (
    <Badge
      variant="outline"
      className={cn(
        'gap-1 border-amber-400/50 bg-amber-50 px-1.5 py-0 text-[10px] font-medium text-amber-700',
        className,
      )}
    >
      <FlaskConical className="h-2.5 w-2.5" />
      Test
    </Badge>
  );
}
